import { useCallback } from 'react'

import { Tooltip } from '@/components/primitives/Tooltip'
import { FitSelectedToMap, FitToMap } from '@/icons'
import { useFitMapToSelection } from '@/map'

import { StyledButton } from '../../hooks/useStyles'
import { useFitAll } from './hooks/useFitAll'
import { useTexts } from './hooks/useTexts'

export function FitAllToggle() {
  const fitMapToSelection = useFitMapToSelection({ forceFit: true })
  const fitSelection = useFitAll()
  const texts = useTexts()

  const tooltip = fitSelection ? texts.fitMapToSelection : texts.fitMap

  const testid = 'map-controls-fit-map'

  const onClick = useCallback(() => {
    fitMapToSelection()
  }, [fitMapToSelection])

  return (
    <Tooltip placement="bottom" title={tooltip}>
      <StyledButton onClick={onClick} data-testid={testid} data-trackid={testid}>
        {fitSelection ? (
          <FitSelectedToMap size={13} color="$nightRider" />
        ) : (
          <FitToMap size={13} color="$nightRider" />
        )}
      </StyledButton>
    </Tooltip>
  )
}
